import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import SubscriptionGate from "@/auth/subscription-gate";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <SubscriptionGate>
      <div className="min-h-screen flex">
        <Sidebar collapsed={collapsed} />
        <div className={`flex-1 flex flex-col transition-all duration-300 ${collapsed ? "ml-16" : "ml-60"}`}>
          <Header collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
          <main className="flex-1 mt-16 p-6 min-h-[calc(100vh-4rem)]">
            <Outlet />
          </main>
        </div>
      </div>
    </SubscriptionGate>
  );
}
